webpackJsonp([88605697669780],{

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  list-style: none;\n  display: flex;\n  margin: 0px 0px 0px 0px;\n  float: right;\n'], ['\n  list-style: none;\n  display: flex;\n  margin: 0px 0px 0px 0px;\n  float: right;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-size: 18px;\n  margin: 0px 10px 5px 0px;\n  color: #f09d57;\n  text-transform: uppercase;\n  a {\n    text-decoration: none;\n    color: #777777;\n    &:hover {\n      border-bottom: 3px solid #E26741;\n    }\n  }\n'], ['\n  font-size: 18px;\n  margin: 0px 10px 5px 0px;\n  color: #f09d57;\n  text-transform: uppercase;\n  a {\n    text-decoration: none;\n    color: #777777;\n    &:hover {\n      border-bottom: 3px solid #E26741;\n    }\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  h2 {\n    font-size: 36px;\n  }\n'], ['\n  h2 {\n    font-size: 36px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(23);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _separator = __webpack_require__(24);
	
	var _separator2 = _interopRequireDefault(_separator);
	
	var _styledTexts = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Tags = _styledComponents2.default.ul(_templateObject);
	
	var Tag = _styledComponents2.default.li(_templateObject2);
	
	var ContentContainer = _styledComponents2.default.div(_templateObject3);
	
	var PostPage = function (_Component) {
	  _inherits(PostPage, _Component);
	
	  function PostPage() {
	    _classCallCheck(this, PostPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PostPage.prototype.render = function render() {
	    var data = this.props.data;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        Tags,
	        null,
	        data.markdownRemark.frontmatter.tags.map(function (tag) {
	          return _react2.default.createElement(
	            Tag,
	            null,
	            tag
	          );
	        })
	      ),
	      _react2.default.createElement(
	        _styledTexts.MyH4,
	        null,
	        data.markdownRemark.frontmatter.date
	      ),
	      _react2.default.createElement(
	        _styledTexts.MyH1,
	        null,
	        data.markdownRemark.frontmatter.title
	      ),
	      _react2.default.createElement(ContentContainer, {
	        dangerouslySetInnerHTML: {
	          __html: data.markdownRemark.html
	        }
	      }),
	      _react2.default.createElement(_separator2.default, null)
	    );
	  };
	
	  return PostPage;
	}(_react.Component);
	
	exports.default = PostPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-posts-post-page-js-2cc46e1e382f315bd2af.js